import { Datagrid, EditButton, List, ShowButton, TextField, TextInput, useTranslate } from "react-admin";

import { rowStyles } from "../../utils/rowStyles";
import { ListPagination } from "../../utils/components/ListPagination";

import { ListActions } from "../../common/ListActions";

export function ArtistList(): JSX.Element {
    const t = useTranslate();

    const filters = [<TextInput key="searchTerms-filter" label={t("resources.artist.fields.fullName")} source="searchTerms" alwaysOn />];

    return (
        <>
            <List pagination={<ListPagination />} perPage={20} filters={filters} actions={<ListActions />}>
                <Datagrid rowStyle={rowStyles}>
                    <TextField source="fullName" />
                    <EditButton />
                    <ShowButton />
                </Datagrid>
            </List>
        </>
    );
}
